import { Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';

import createSafeContext from '#/utils/createSafeContext';

interface WithdrawModalActions {
  readonly open: () => void;
  readonly close: () => void;
}

interface WithdrawModalState {
  readonly isOpen: boolean;
}

const INITIAL_STATE: WithdrawModalState = {
  isOpen: false,
};

interface WithdrawModalView {
  readonly isOpen: boolean;
}

export const [useWithdrawModalView, ModalViewProvider] =
  createSafeContext<WithdrawModalView>('WithdrawModalView');

export const [useWithdrawModalActions, ModalActionsProvider] =
  createSafeContext<WithdrawModalActions>('WithdrawModalActions');

interface Props {
  readonly children: ReactNode;
}

export const WithdrawModalProvider = ({ children }: Props) => {
  const [state, setState] = useState(INITIAL_STATE);

  const actions = useMemo(() => createActions(setState), []);
  const view = useMemo(() => createView(state), [state]);

  return (
    <ModalViewProvider value={view}>
      <ModalActionsProvider value={actions}>{children}</ModalActionsProvider>
    </ModalViewProvider>
  );
};

function createActions(
  setState: Dispatch<SetStateAction<WithdrawModalState>>,
): WithdrawModalActions {
  return {
    open() {
      setState({ ...INITIAL_STATE, isOpen: true });
    },
    close() {
      setState({ ...INITIAL_STATE, isOpen: false });
    },
  };
}

function createView(state: WithdrawModalState): WithdrawModalView {
  const { isOpen } = state;
  return { isOpen };
}
